export default "__VITE_ASSET__CFa1vgb9__"